import { Link, useLocation } from 'react-router-dom';
import { ChefHat, Heart } from 'lucide-react';

const Navbar = () => {
  const location = useLocation();

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-nav border-b border-border" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-home-link">
            <div className="bg-primary rounded-full p-2.5 group-hover:scale-110 transition-transform duration-300">
              <ChefHat className="w-6 h-6 text-primary-foreground" />
            </div>
            <span className="text-2xl font-semibold text-foreground">The Sous-Chef - Kya Banaoo</span>
          </Link>
          
          <div className="flex items-center gap-6">
            <Link
              to="/"
              data-testid="nav-find-recipes-link"
              className={`text-base font-medium transition-colors duration-200 ${
                location.pathname === '/'
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              Find Recipes
            </Link>
            <Link
              to="/saved"
              data-testid="nav-saved-recipes-link"
              className={`flex items-center gap-2 text-base font-medium transition-colors duration-200 ${
                location.pathname === '/saved'
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Heart className="w-5 h-5" />
              Saved Recipes
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;